// extracted by mini-css-extract-plugin
export var addWidgetButton = "_v-6";
export var backButton = "_v-1";
export var legacyWidgetContainer = "_v-5";
export var pageContainer = "_v-2";
export var settingsContent = "_v-0";
export var widgetSubsectionItem = "_v-3";
export var widgetSubsectionItemContent = "_v-4";